import { render, staticRenderFns } from "./ThreeDotMenu.vue?vue&type=template&id=4c1b061e&scoped=true&"
import script from "./ThreeDotMenu.vue?vue&type=script&lang=js&"
export * from "./ThreeDotMenu.vue?vue&type=script&lang=js&"
import style0 from "./ThreeDotMenu.vue?vue&type=style&index=0&id=4c1b061e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1b061e",
  null
  
)

export default component.exports